import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import axios from 'src/app/Service/axios';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';

declare let $: any;

@Component({
  selector: 'app-validity-modal',
  templateUrl: './validity-modal.component.html',
  styleUrls: ['./validity-modal.component.css'],
})
export class ValidityModalComponent {
  validityForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private gurdService: GurdServiceService,
    private notify: NotificationService,
    private otherService: OtherService,
  ) {
    this.validityForm = this.fb.group({
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
      lststrUnitIDs: new FormControl('', Validators.required),
      strValidDate: '',
      iChargingFee: '',
    });
  }

  open(unitIds: string[]): void {
    this.validityForm.patchValue({
      lststrUnitIDs: unitIds,
      iChargingFee: '',
      strValidDate: '',
    });
    $('#Validity_Modal').modal('show');
  }

  async submit(): Promise<void> {
    const model = this.validityForm.value;
    model.lstUnitID = model.lststrUnitIDs;

    if (!model.strValidDate && !model.iChargingFee) {
      return this.notify.showError('ورود یکی از موارد الزامی می باشد');
    }
    if (model.iChargingFee?.includes(',')) {
      model.iChargingFee = model.iChargingFee.replace(/,/g, '');
    }

    this.otherService.Showspinner();
    const res = JSON.parse(
      (
        await axios.post(
          `Mobiles_UpdateMobileValidDateOriChargingFee`,
          this.otherService.stringNumberToNumber(model),
        )
      ).data,
    );
    this.otherService.nonespinner();

    if (res.iResult == 0) return this.notify.showError(res.strError);

    $('#Validity_Modal').modal('hide');
    return this.notify.showSuccess('عملیات با موفقیت انجام شد');
  }
}
